<div class="child-inventory-form" style="height:auto">

  <form #convertForm="ngForm" class="form-flow" style="height:auto">
    <app-inventory-website-visibility [(invisible)]="WebInvisible"></app-inventory-website-visibility>
    <div class="conversion-source">
      <span class="source-label">Convert From</span>
      <strong>{{sourceTypeName}}</strong>
      <span class="source-reference">Ref #{{InventoryItem.InventoryID}} · SKU #{{InventoryItem.InventoryTypeID}}</span>
    </div>

    <fieldset class="rms-fieldset">
      <legend>Available inventory</legend>

      <div class="fields">

        <rms-input type="decimal"
                   name="NetWeight"
                   label="Net Weight"
                   [ngModel]="InventoryItem.NetWeight"
                   [disabled]="true">
        </rms-input>

        <rms-number name="AvailableBags"
                    label="Bags Available"
                    [disabled]="true"
                    [ngModel]="availableBags">
        </rms-number>

        <rms-input type="decimal"
                   name="AvailableWeight"
                   label="Available Weight"
                   [disabled]="true"
                   [ngModel]="availableWeight">
        </rms-input>

      </div>
    </fieldset>


    <fieldset class="rms-fieldset conversion-config">
      <legend>Conversion details</legend>

      <rms-search-select name="InventoryType"
                  [required]="true"
                  label="Convert To"
                  [(ngModel)]="InventoryTypeID"
                  [options]="CoffeeTypes"
                  labelKey="InventoryTypeName"
                  valueKey="InventoryTypeID">
      </rms-search-select>

      <rms-number name="BagsReconciled"
                  [required]="true"
                  label="Bags To Recondition"
                  [(ngModel)]="BagsReconciled">
      </rms-number>

    </fieldset>


    <div class="conversion-reason">
      <rms-textarea name="ConversionReason" label="Reason for SKU conversion" [required]="true" [(ngModel)]="ConversionReason" placeholder="Explain why, for example QC findings or damaged bags."></rms-textarea>
      <small>A reason is required and saved with the converted reference.</small>
    </div>
    @if (conversionPreview) {

    <fieldset class="rms-fieldset conversion-preview">
      <legend>Conversion summary</legend>
      <div class="conversion-row"><span>Convert From</span><strong>{{sourceTypeName}}</strong></div>

      <div class="conversion-row">
        <span>Bags To Recondition</span>
        <strong>
          {{ conversionPreview.bags }}
        </strong>
      </div>

      <div class="conversion-row">
        <span>Weight Per Bag</span>
        <strong>
          {{ conversionPreview.netWeight | number:'1.0-2' }} lbs
        </strong>
      </div>

      <div class="conversion-row">
        <span>Total Weight</span>
        <strong>
          {{ conversionPreview.totalWeight | number:'1.0-2' }} lbs
        </strong>
      </div>

      @if (conversionPreview.typeName) {
      <div class="conversion-row destination">
        <span>Convert To</span>
        <strong>
          {{ conversionPreview.typeName }}
        </strong>
      </div>
      }

    </fieldset>

    }


    @if (validationMessage || errorMessage) {
    <div class="sm-font text-red">
      {{ validationMessage || errorMessage }}
    </div>
    }

  </form>


  <div class="button-container">

    <button type="button" mat-button
            class="btn-bg-green"
            [disabled]="!convertForm.valid || !canSave"
            (click)="save()">
      Save
    </button>

    <button mat-button
            class="btn-bg-red"
            (click)="cancel()">
      Cancel
    </button>

  </div>

</div>
